import React, { SyntheticEvent, useCallback } from 'react';
import type { TFieldsetProps } from './types';
import { StyledFieldset } from './styles';

export const Fieldset = (props: TFieldsetProps) => {
    const { id, children, className, isDisabled, 'data-testid': dataTestid } = props;

    const preventSyntheticEventIfDisabled = useCallback(
        (e: SyntheticEvent) => {
            if (isDisabled) {
                e.stopPropagation();
            }
        },
        [isDisabled]
    );

    return (
        <StyledFieldset
            id={id}
            data-testid={dataTestid || `elmo-fieldset-${id || 'default'}`}
            className={className}
            disabled={isDisabled}
            onDrop={preventSyntheticEventIfDisabled}
            onDragEnter={preventSyntheticEventIfDisabled}
            onDragStart={preventSyntheticEventIfDisabled}
        >
            {children}
        </StyledFieldset>
    );
};
